import React from "react";

export default function Avatar({ label, src, size = "md", color = "bg-gray-200", textColor = "text-gray-500" }) {
  const [imgError, setImgError] = React.useState(false);
  const sizes = {
    sm: "w-8 h-8 text-[10px]",
    md: "w-10 h-10 text-xs",
    lg: "w-12 h-12 text-sm",
    xl: "w-24 h-24 text-3xl"
  };
  const sizeClass = sizes[size] || sizes.md;
  const imageUrl = !imgError && (src || (typeof label === "string" && (label.startsWith("http://") || label.startsWith("https://")) ? label : null));
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setImgError(true)}
        className={`${sizeClass} rounded-full object-cover shrink-0 ring-2 ring-white shadow-sm`}
      />
    );
  }
  const initials = (typeof label === "string" && !label.startsWith("http") ? label : "")?.substring(0, 2) || "??";
  return (
    <div className={`${sizeClass} ${color} ${textColor} rounded-full flex items-center justify-center font-bold uppercase shrink-0 ring-2 ring-white shadow-sm`}>
      {initials}
    </div>
  );
}
